export const INVOKE_FUNCTION = 'INVOKE_FUNCTION';

// NOTE: Messasges in this file are intended for use with `iframeable`

export const isInvokeFunctionMessage = msg => {
  const {
    payload
  } = msg;
  return payload.type === INVOKE_FUNCTION && 'args' in payload && 'fnName' in payload;
};